import { redesSociais } from '@/core/data/redes-sociais'
import {
  RedesSociaisQueryQuery,
  RedesSociaisQueryQueryVariables
} from '@/core/types/graphql'
import { useUsuarioLogado } from '@/core/hooks/use-usuario-logado'
import { split } from '@/core/utils/split'
import { useQuery } from '@tanstack/react-query'
import { request } from '../../../core/utils/request'

export const useRedesSociais = () => {
  const { usuarioLogado } = useUsuarioLogado()
  const marcaAtual = usuarioLogado?.marcas?.[0]?.id

  const redesSociaisQuery = useQuery({
    queryKey: ['redesSociais'],
    queryFn: async () =>
      await request<RedesSociaisQueryQuery, RedesSociaisQueryQueryVariables>(
        redesSociais,
        { variables: { marca: marcaAtual ?? '' } }
      ),
    enabled: !!marcaAtual
  })

  return redesSociaisQuery.data?.redesSociais?.map(rede => {
    const [pack, name] = split(rede?.icone ?? '', '|')

    return {
      ...rede,
      pack,
      name
    }
  })
}
